import React, { useState } from "react";
import { useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Table,
  TableBody,
  Typography,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  styled,
  Divider,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Checkbox from "@mui/material/Checkbox";
import { useHistory } from "react-router-dom";
import { getManufacturers } from "./api/manufacturerApi";

const OverviewItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isFirst",
})(({ theme, isFirst }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "70px",
  flexGrow: 1,
  textAlign: "center",
  backgroundColor: "#1b5e20",
  padding: "4px",
  borderRadius: "2px",
  color: "white",
  ...(isFirst
    ? {}
    : {
        borderLeft: "1px solid white",
      }),
}));

const ManufacturerOverview = () => {
  const [manufacturers, setManufacturers] = useState([]);
  const history = useHistory();

  const handleRegisterClick = () => {
    history.push("/register-manufacturer");
  };

  useEffect(() => {
    const fetchManufacturers = async () => {
      try {
        const data = await getManufacturers();
        setManufacturers(data);
        console.log("Manufacturers list:", data);
      } catch (error) {
        console.error("Error fetching manufacturers:", error.message);
      }
    };

    fetchManufacturers();
  }, []);

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#1b5e20",
          padding: "16px",
          display: "flex",
          gap: "20px",
          alignItems: "center",
          marginBottom: "20px",
          borderRadius: "4px",
        }}
      >
        <OverviewItem isFirst>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Total Seller
          </Typography>
          <Typography variant="h6">10</Typography>
        </OverviewItem>
        <OverviewItem>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Manufacturer
          </Typography>
          <Typography variant="h6">25</Typography>
        </OverviewItem>
        <OverviewItem>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Vendor
          </Typography>
          <Typography variant="h6">36</Typography>
        </OverviewItem>
        <OverviewItem>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Manufacturer Machines
          </Typography>
          <Typography variant="h6">65</Typography>
        </OverviewItem>
        <OverviewItem>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Seller Machines
          </Typography>
          <Typography variant="h6">87</Typography>
        </OverviewItem>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
          padding: "0 16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
            paddingLeft: "8px",
          }}
        >
          <SearchIcon color="action" />
          <TextField
            placeholder="Search here..."
            variant="standard"
            size="small"
            sx={{
              ml: 1,
              "& .MuiInput-underline:before": { borderBottom: "none" },
              "& .MuiInput-underline:after": { borderBottom: "none" },
            }}
          />
        </Box>
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          style={{ borderRadius: "4px" }}
          onClick={handleRegisterClick}
        >
          Register Manufacturer
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        style={{ borderRadius: "4px", margin: "0 16px" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="seller overview table">
          <TableHead style={{ backgroundColor: "#1b5e20" }}>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox size="small" />
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Manufacturer Name
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Email
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                GSTIN Number
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Contact Number
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                City
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Address Type
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Address Lane 1
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "white" }}>
                Address Lane 2
              </TableCell>
              <TableCell
                align="right"
                style={{ fontWeight: "bold", color: "white" }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {manufacturers.map((manufacturer) => (
              <TableRow
                key={manufacturer.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell padding="checkbox">
                  <Checkbox size="small" />
                </TableCell>
                <TableCell>{manufacturer.name}</TableCell>
                <TableCell>{manufacturer.email}</TableCell>
                <TableCell>{manufacturer.gstin}</TableCell>
                <TableCell>{manufacturer.contact}</TableCell>
                <TableCell>{manufacturer.city}</TableCell>
                <TableCell component="th" scope="row">
                  {manufacturer.addressType}
                </TableCell>
                <TableCell style={{ color: "#757575" }}>
                  {manufacturer.addressLane1}
                </TableCell>
                <TableCell style={{ color: "#757575" }}>
                  {manufacturer.addressLane2}
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="View">
                    <IconButton aria-label="view" size="small">
                      <VisibilityIcon color="action" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <IconButton aria-label="edit" size="small">
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton aria-label="delete" size="small">
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ManufacturerOverview;
